export default {
    GAS_ELECTRIC: 'gas-electric',
    HEAT_PUMP: 'heat-pump',
    TANKLESS: 'tankless',
    CENTRAL_SUPPLY: 'central-supply',
    NONE: 'none',
};
